import { Stack, Typography, useTheme } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

function DetailRow({ label, value }: Props) {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      gap={1}
      justifyContent="space-between"
      borderTop={`1px solid ${theme.palette.lightGrey.main}`}
      py={1.5}>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
}

export default DetailRow;
